import { useNavigate } from 'react-router-dom';

export default function ArticleCards() {
  const navigate = useNavigate();

  const articles = [
    {
      title: 'Complete CSSBuy Spreadsheet Guide 2026',
      desc: 'Everything you need to know about finding and using the best CSSBuy spreadsheet for agent shopping.',
      tag: 'Guide',
      highlight: true,
      link: '/cssbuy-spreadsheet-complete-guide',
    },
    {
      title: 'CSSBuy vs Kakobuy Spreadsheet Comparison',
      desc: 'Which agent shopping spreadsheet platform delivers the best finds? A detailed side-by-side analysis.',
      tag: 'Comparison',
      highlight: false,
      link: '/cssbuy-vs-kakobuy-spreadsheet',
    },
    {
      title: 'Complete Shopping Guide for Beginners',
      desc: 'A step-by-step walkthrough on navigating and maximizing spreadsheet finds across all platforms.',
      tag: 'Tutorial',
      highlight: false,
      link: '/shopping-guide',
    },
    {
      title: 'How to Size Correctly from CSSBuy Sheet',
      desc: 'Master Asian sizing conversions and never order the wrong size again when shopping through spreadsheets.',
      tag: 'Tips',
      highlight: false,
      link: '/shopping-guide',
    },
    {
      title: 'Best Budget Spreadsheet Finds Under $50',
      desc: 'Discover affordable gems from Oopbuy and CSSBuy spreadsheets without breaking the bank.',
      tag: 'Budget',
      highlight: false,
      link: '/cssbuy-vs-kakobuy-spreadsheet',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center mx-auto mb-3 md:mb-4 text-accent-500">
            <i className="ri-article-line text-2xl md:text-3xl"></i>
          </div>
          <span className="inline-block text-xs md:text-sm font-medium text-accent-600 uppercase tracking-wide mb-2">
            SEO Resources
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            CSSBuy Sheet Knowledge Base
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Dive deeper into the world of agent shopping spreadsheets with our in-depth guides and comparisons.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          <button
            onClick={() => navigate(articles[0].link)}
            className="col-span-1 sm:col-span-2 lg:col-span-1 lg:row-span-2 bg-accent-100 rounded-lg p-6 md:p-8 text-left hover:bg-accent-200/80 transition-all duration-300 group cursor-pointer flex flex-col justify-between min-h-[320px]"
          >
            <div>
              <span className="inline-block px-3 py-1 bg-accent-200 text-accent-800 rounded-full text-xs font-medium mb-4">
                {articles[0].tag}
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3 group-hover:text-accent-800 transition-colors">
                {articles[0].title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {articles[0].desc}
              </p>
            </div>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-700 mt-4 group-hover:gap-2.5 transition-all">
              Read Full Guide
              <i className="ri-arrow-right-line"></i>
            </span>
          </button>

          {articles.slice(1).map((article) => (
            <button
              key={article.title}
              onClick={() => navigate(article.link)}
              className="bg-background-50 rounded-lg p-5 md:p-6 text-left hover:bg-primary-50 transition-all duration-300 group cursor-pointer flex flex-col justify-between"
            >
              <div>
                <span className="inline-block px-2.5 py-0.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium mb-3">
                  {article.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-700 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {article.desc}
                </p>
              </div>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 mt-3 group-hover:gap-1.5 transition-all">
                Read More
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}